module.exports = __webpack_public_path__ + "media/bootstrap-icons/slash-square-fill-cf60d262.svg";